if (carouselReviews == true) {
    $('#reviews').slick({
        slidesToShow: 1,
        arrows: false,
        dots: true,
        speed: 700,
        autoplaySpeed: 800,
        adaptiveHeight: true
    });
}